import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from "vue";
import { $alert } from "@/plugins/alert/alert";
import { $get, $post } from "@/plugins/api/api";
import { Paths } from "@/plugins/api/paths";
import { OverworkFlowDat } from "@/models/transaction/OverworkFlowDat";
import { InputRules } from "@/rules";
import {
  PulldownResponse,
  codeKbnFilter
} from "@/models/response/PulldownResponse";
import { CodeKbnList } from "@/models/codeMaster/Code";
import TimePicker2 from "@/components/TimePicker2.vue";
import { DateTime } from "luxon";

interface VForm extends Vue {
  reset(): void;
  resetValidation(): void;
  validate(): boolean;
}

type Valid = typeof Valid[keyof typeof Valid];

type Props = {
  item: OverworkFlowDat;
  disabled: boolean;
};
type Emits = {
  (e: "close"): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'OverworkDialog',
  props: {
    item: null,
    disabled: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "close"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  item: OverworkFlowDat;
  disabled: boolean;
};

const Valid = {
  On: "1",
  Off: "0"
} as const;
const segmentItems = [
  { text: "残業あり", value: Valid.On },
  { text: "残業なし", value: Valid.Off }
] as const;




const vform = ref<VForm>();

const reasonList = ref<string[]>([]);

const isLoading = ref(false);

const dat = ref(Object.assign({}, props.item));

const isOpen = ref(false);

const segment = ref<number>(0);

const valid = computed(() => segmentItems[segment.value].value);

const getCodeMaster = async () => {
  const code = await $get<PulldownResponse[]>(Paths.codeMasterPulldown);
  if (code) {
    reasonList.value = codeKbnFilter(code, CodeKbnList.OVRSN).map(e => e.name);
  }
};

const onClose = () => {
  isOpen.value = false;
  emits("close");
};

const onSubmit = async () => {
  if (!vform.value?.validate()) {
    $alert("warning", "入力に誤りがあります。\n入力内容を確認してください。");
    return;
  }

  isLoading.value = true;
  dat.value.isOverwork = valid.value;
  const result = await $post(Paths.approval.overtimeWork.update, dat.value);
  if (result) {
    $alert("success", "変更に成功しました。");
    onClose();
  } else {
    $alert("error", "変更に失敗しました。");
  }
  isLoading.value = false;
};

const endTime = ref<DateTime>();
const breakTime = ref<DateTime>();
const overtimeRule = (val: unknown) => {
  const from = typeof val === "string" ? DateTime.fromISO(val) : undefined;
  const to = endTime.value;
  if (!from?.isValid || !to?.isValid) return true;
  const time = to.toFormat("HH時mm分");
  return from > to || `${time}よりも遅い時間を選択してください。`;
};
const breakTimeRules = (val: unknown) => {
  const from = typeof val === "string" ? DateTime.fromISO(val) : undefined;
  const to = breakTime.value;
  if (!from?.isValid || !to?.isValid) return true;
  const time = to.toFormat("HH時mm分");
  return +from === +to || `休憩時間を${time}で登録してください。`;
};

const getBreakTime = async (shiftId: string) => {
  const path = `${Paths.approval.overtimeWork.breakTime}/${shiftId}`;
  return await $get<string>(path);
};
const getEndTime = async (shiftId: string) => {
  const path = `${Paths.approval.overtimeWork.endTime}/${shiftId}`;
  return await $get<string>(path);
};
watch(
  () => props.item.shiftId,
  async val => {
    if (val) {
      const time = await getBreakTime(val);
      const et = await getEndTime(val);
      breakTime.value = time ? DateTime.fromISO(time) : undefined;
      endTime.value = et ? DateTime.fromISO(et) : undefined;
    }
  },
  { immediate: true }
);

const initialize = async () => {
  await getCodeMaster();
  dat.value = Object.assign({}, props.item);
  if (dat.value.isOverwork === "0") segment.value = 1;
  if (!dat.value.overtimeWorkEnd) dat.value.overtimeWorkEnd = "";
};

watch(isOpen, async () => {
  if (isOpen) {
    await initialize();
  }
});

return { __sfc: true,Valid, segmentItems, props, emits, vform, reasonList, isLoading, dat, isOpen, segment, valid, getCodeMaster, onClose, onSubmit, endTime, breakTime, overtimeRule, breakTimeRules, getBreakTime, getEndTime, initialize, InputRules, TimePicker2 }
}

})